import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { FileSizePipe, ImmomioIconName, IResidentS3File } from '@resident-nx/shared';
import { CardWebComponent, Elevation, IconWebComponent } from '@resident-nx/web/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-pdf-attachment',
  imports: [IconWebComponent, CardWebComponent, TranslateModule, FileSizePipe],
  templateUrl: './pdf-attachment.component.html',
  styleUrl: './pdf-attachment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfAttachmentComponent {
  // we want to support File and S3File type. We can't use a union type because s3File is missing size property
  file = input<File>();
  s3File = input<IResidentS3File>();
  fileOrS3File = computed(() => this.file() ?? this.s3File());
  isRemovable = input(true);
  maxFileSize = input<number>(null);
  name = computed(() => this.s3File()?.title || this.fileOrS3File().name);
  isFileTooBig = computed(() => {
    if (!this.maxFileSize()) {
      return false;
    }
    return this.file().size > this.maxFileSize();
  });
  remove = output();
  protected readonly Elevation = Elevation;
  protected readonly ImmomioIconName = ImmomioIconName;
}
